<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分类" prop="type" >
        <a-select v-model="form.type">
          <a-select-option v-for="item in foodWeight" :value="item.id" :key='item.id'>{{item.dictLabel}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="图片" prop="image" >
        <file-upload type="image" :defaultList="form.imageArr" :count="1" :imgSize="'160*160'"
                     @input="getImg($event, 'image')"></file-upload>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
// import { getFoodWeight, addFoodWeight, updateFoodWeight } from '@/api/foodWeight/foodWeight'
import {getDicts} from "@/api/system/dict/data";
import {guid} from "@/utils/ruoyi";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      foodWeight:[],
      // 表单参数
      form: {
        id: null,

        type: null,

        image: null,
        imageCount:1,
        imageArr:[],
        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '分类不能为空', trigger: 'change' }
        ],
        image: [
          { required: true, message: '图片不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initDict()
  },
  activated() {
    this.initDict()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    initDict(){
      getDicts('food_weigh').then(res=>{
        this.foodWeight = res.data
      })
    },

    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        image: null,
        imageCount:1,
        imageArr:[],
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.open = true
      this.formType = 2
      const id = row ? row.id : ids
      getFoodWeight({"id":id}).then(response => {
        this.form = response.data
        this.formTitle = '修改'
        let that = this
        if(this.form.image){
          this.form.imageArr = []
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateFoodWeight(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFoodWeight(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
